module.exports = __webpack_public_path__ + "img/au.ca0ed186.svg";